import * as yup from 'yup'

import { CustomerResult } from './MovingContractModels'

export const OperationValidationSchema = yup.object().shape({
  // _id: yup.string().matches(/^[a-f\d]{24}$/i, { excludeEmptyString: true }),
  moverCount: yup.number().integer('Must be either 2 or 3').min(2).max(3).required(),
  duration: yup.number().min(1).required(),
  earlyStart: yup.boolean(),
  earlyStartNotes: yup
    .string()
    // .when('earlyStart', {
    //   is: true,
    //   then: (schema: { required: (arg0: string) => unknown }) =>
    //     schema.required('Notes are required when Early Start is indicated.'),
    // })
    .nullable(),
})

export interface IBookingEnvelope {
  jobStart: string
  jobDuration: number
  bookingStart: string
  bookingDuration: number
  startingDriveTime: number
  startingTripFee: number
  endingDriveTime: number
  endingTripFee: number
}
export interface IOperation {
  _id?: string
  date: string
  duration: number
  earlyStart: boolean
  earlyStartNotes?: string
  moverCount: number
  timezone: string
  truck?: string
  unassigned?: boolean
  bookingEnvelope: IBookingEnvelope
}

export interface IOperationMetaData {
  customerName: string
  fromZone: string
  toZone: string
  interimLocations: number
  requiresLift: boolean
  fromFloor: number
  toFloor: number
  stopCount: number
  moverCount: number
  startTime: string
  endTime: string
  earlyStart: boolean
  earlyStartNotes: string
  duration: number
  date: string
  timezone: string
  customer: {
    _id: string
    courtesyCall?: {
      sent: boolean
    }
  }
  activity: any
  hasNextDayActivity: boolean
  hasPrevDayActivity: boolean
  isReservation: boolean
  expiry?: number
  nounce: string
  state: string
  bookingEnvelope?: IBookingEnvelope
}

export interface IOperationPayload {
  customerId: string
  activityId: string
  operation: IOperation
  customer?: CustomerResult
  delete?: boolean
}

export interface OperationAssignmentPayload {
  customerNounce: string
  truck: string
}

export interface IReservation extends IOperation {
  expiry: number
}
